import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
// eslint-disable-next-line max-len
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import { syncTwrDevices } from '@app/actions/scenes/twrDevices/twrDevices'
import { isIOS } from 'react-device-detect'
import DevicesList
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/MezzoConditions/TimersConditions/SelectDeviceCommon/DevicesList/DevicesList'
import DevicesListIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/MezzoConditions/TimersConditions/SelectDeviceCommon/DevicesList/DevicesList'
import { withAccessDenied, withProgressAndErrorMessage, withRefresh } from '@app/hocs'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'
import { ITwrDeviceBackend } from '@app/@types/scenes/scenesDevices'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? DevicesListIOS : DevicesList

const mapStateToProps = (state: AppState) => {
  const { isMobile } = state.mobileDetector
  const { devices: allDevices } = state.scenes.twrDevices
  const devices = allDevices.filter((device: ITwrDeviceBackend) => device.device_type !== 'Keyfob')
  const { deviceType } = state.scenes.currentSceneCreating.currentCondition
  return {
    isMobile,
    devices,
    deviceType,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  refresh: syncTwrDevices,
  tryAgain: syncTwrDevices,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const DevicesListEnhanced = enhance

export default DevicesListEnhanced
